import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const VARIANTS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            visibility: 'visibility',
            unitSize: 'unitSize',
            unitPrice: 'unitPrice',
            unitStock: 'unitStock',
            unitGramEQ: 'unitGramEQ'
        }),
        [MODE_PROD]: Object.freeze({
            visibility: 'v',
            unitSize: 'us',
            unitPrice: 'up',
            unitStock: 'ust',
            unitGramEQ: 'uqe'
        })
    })
})()

export const STORE_PRODUCTS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            visibility: 'visibility',
            variants: 'variants'
        }),
        [MODE_PROD]: Object.freeze({
            visibility: 'v',
            variants: 'va'
        })
    })
})()
